export default __webpack_public_path__ + "static/media/repair-fill.b7824c8c.svg";